import { queryClient } from "@/lib/queryClient";
import { CreateLeaguePage } from "./CreateLeaguePage";

export function CreateLeagueWrapper() {
  return (
    <CreateLeaguePage
      onCreateLeague={(data) => {
        fetch("/api/leagues", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
          credentials: "include",
        }).then((res) => {
          if (res.ok) {
            queryClient.invalidateQueries({ queryKey: ["/api/leagues"] });
          }
        });
      }}
    />
  );
}
